import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { ReactComponent as Workicon } from "./work.svg";

import "react-vertical-timeline-component/style.min.css";

import "./upcomingpast.css"

let extractor = (link) => {
  if (link.search("google.com") !== -1) {
    var id = link.split("=");
    let url_link = "https://drive.google.com/uc?export=view&id=";
    var url = url_link.concat(id[1]);
  } else {
    url = link;
  }
  return url;
}




let past = ({ pastevents }) => {
  return (
    <div>
      <VerticalTimeline id="timeline">

        {pastevents.length !== 0 ? pastevents.map((Events) => {
          return (
            <VerticalTimelineElement
              key={Events[0]}
              className="vertical-timeline-element--work"
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              icon={<Workicon />}



              contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(173,255,47)",
              }}
              date={Events[2]}
            >
              <img className='image' src={extractor(Events[5])} alt="Logo" />

              <h3 className="vertical-timeline-element-title titlee">
                {Events[1]}
              </h3>
              <hr />
              <p className="venue">Venue: {Events[6]}</p>

              <h4 className="vertical-timeline-element-subtitle description">   {Events[4]}
              </h4>
              <br />

              <a href={Events[7]} target="__blank" rel="noreferrer"><button className="timelinebutton">Event   &#8599;</button> </a >

            </VerticalTimelineElement>

          );

        }) : (

          <h1 className="nocontent" >

            &nbsp; 	&#128517; Oops! Something is wrong...







          </h1>

        )
        }


      </VerticalTimeline>;
    </div>
  );
};

export default past;